import type { OrganizationsTranslations } from "../interfaces/organizations";

export const organizationsTranslations: OrganizationsTranslations = {
  page_title: "Organizações",
  page_subtitle:
    "Busque uma organização e abra o painel dela para decidir quais funcionalidades os membros veem",
  action_refresh: "Atualizar a lista",
  action_retry: "Tentar de novo",
  action_clear_filters: "Limpar filtros",
  error_load: "Não conseguimos carregar as organizações.",

  filter_search_label: "Buscar",
  filter_search_placeholder: "Nome, e-mail, ID ou usuário…",
  filter_search_min_length: "Digite pelo menos {{count}} caracteres para buscar.",
  filter_status_label: "Status",
  filter_status_all: "Todos os status",
  filter_payout_batches_label: "Pagamentos em lote",
  filter_payout_batches_all: "Todas",
  filter_payout_batches_enabled: "Habilitadas",
  filter_payout_batches_disabled: "Não habilitadas",

  col_name: "Organização",
  col_country: "País",
  col_status: "Status",
  col_created: "Criada",
  col_payout_batches: "Pagamentos em lote",
  value_none: "—",

  status_active: "Ativa",
  status_inactive: "Inativa",
  status_suspended: "Suspensa",
  status_pending: "Pendente",

  payout_batches_switch_aria: "Pagamentos em lote para {{name}}",

  empty_title: "Ainda não há organizações",
  empty_description: "As organizações clientes aparecerão aqui quando se cadastrarem.",
  empty_filtered_title: "Nenhuma organização corresponde",
  empty_filtered_description: "Tente outro termo ou limpe os filtros.",

  disable_dialog_title: "Remover pagamentos em lote de {{name}}?",
  disable_dialog_description:
    "Seus membros deixarão de ver o módulo e não poderão enviar, revisar nem aprovar lotes. Os lotes que já estão sendo pagos terminam normalmente, e a equipe Coloca continua vendo-os.",
  disable_dialog_confirm: "Remover acesso",
  disable_dialog_cancel: "Cancelar",

  toast_payout_batches_enabled: "Pagamentos em lote habilitados para {{name}}",
  toast_payout_batches_disabled: "Pagamentos em lote desabilitados para {{name}}",
  col_breb_key: "Chave Bre-B",
  breb_key_switch_aria: "Chave Bre-B para {{name}}",
  toast_breb_key_enabled: "Chave Bre-B habilitada para {{name}}",
  toast_breb_key_disabled: "Chave Bre-B desabilitada para {{name}}. Se já tinha uma, ela continua.",
  rollout_body_on: "Ligada para todas as organizações verificadas, independentemente da chave própria.",
  rollout_body_off: "Cada uma decide: só as organizações que você habilitar uma a uma a têm.",
  rollout_switch_aria: "Chave Bre-B para todas as organizações",
  rollout_confirm_on_title: "Ligar a chave Bre-B para todas as organizações?",
  rollout_confirm_on_body: "Qualquer organização verificada poderá criar sua chave pelo dashboard.",
  rollout_confirm_on_cta: "Ligar para todas",
  rollout_confirm_off_body:
    "Só as organizações habilitadas uma a uma poderão criar uma chave. As chaves que já existem continuam funcionando.",
  rollout_cancel: "Cancelar",
  toast_rollout_on: "Chave Bre-B ligada para todas as organizações",
  toast_rollout_failed: "Não conseguimos mudar o interruptor geral. Tente de novo.",
  rollout_mode_per_organization: "Cada uma decide",
  rollout_mode_on_for_all: "Todas",
  rollout_mode_off_for_all: "Nenhuma",
  rollout_body_off_for_all:
    "Desligada para todas: nenhuma organização a tem, nem as que têm o próprio interruptor ligado. Esse interruptor é mantido e volta a valer quando você tirar o bloqueio.",
  rollout_confirm_per_organization_title: "Deixar cada organização decidir sobre {{feature}}?",
  rollout_confirm_per_organization_cta: "Deixar cada uma decidir",
  rollout_confirm_off_for_all_title: "Desligar {{feature}} para todas as organizações?",
  rollout_confirm_off_for_all_cta: "Desligar para todas",
  rollout_confirm_off_for_all_keeps:
    "O interruptor de cada organização não é alterado: ao voltar para «Cada uma decide», cada uma fica como estava.",
  rollout_confirm_unblock_body:
    "Voltam a tê-la só as organizações com o próprio interruptor ligado, como estavam antes do bloqueio.",
  payout_batches_rollout_confirm_block_body:
    "Os membros de nenhuma organização verão o módulo, nem os das habilitadas. Os lotes que já estão sendo pagos terminam normalmente e a equipe da Coloca continua com acesso.",
  rollout_confirm_block_body:
    "Nenhuma organização poderá criar uma chave nova. As chaves que já existem continuam recebendo pagamentos.",
  crypto_rollout_confirm_block_body:
    "Nenhuma organização poderá comprar nem vender USDT, nem recarregar cartões com pesos, que compra USDT. As operações em andamento terminam normalmente.",
  card_deposits_rollout_confirm_block_body:
    "Nenhum cartão cripto mostrará seu QR de depósito. Os depósitos que chegarem a endereços já compartilhados continuam sendo registrados.",
  card_cop_top_ups_rollout_confirm_block_body:
    "Nenhuma organização poderá recarregar seus cartões com pesos. As recargas em andamento terminam normalmente.",
  breb_qr_payments_rollout_confirm_block_body:
    "Nenhuma organização poderá pagar QR Bre-B. Os pagamentos já enviados seguem seu curso.",
  toast_rollout_per_organization: "{{feature}}: agora cada organização decide",
  toast_rollout_off_for_all: "{{feature}}: desligada para todas as organizações",
  features_off_for_all: "Desligadas para todas: {{features}}",
  feature_blocked_note_on:
    "Desligada para todas pela configuração geral. O próprio interruptor está ligado e volta a valer ao tirar o bloqueio.",
  feature_blocked_note_off: "Desligada para todas pela configuração geral.",
  toast_update_failed: "Não conseguimos atualizar {{name}}. Tente de novo.",
  col_crypto: "Cripto",
  crypto_switch_aria: "Cripto para {{name}}",
  toast_crypto_enabled: "Cripto habilitado para {{name}}",
  toast_crypto_disabled: "Cripto desabilitado para {{name}}. As operações em andamento terminam normalmente.",
  crypto_rollout_body_on: "Ligado para todas as organizações, independentemente da chave própria.",
  crypto_rollout_body_off: "Cada uma decide: só as organizações que você habilitar uma a uma o têm.",
  crypto_rollout_switch_aria: "Cripto para todas as organizações",
  crypto_rollout_confirm_on_title: "Ligar Cripto para todas as organizações?",
  crypto_rollout_confirm_on_body: "Qualquer organização poderá comprar e vender USDT pelo dashboard.",
  crypto_rollout_confirm_off_body:
    "Só as organizações habilitadas uma a uma poderão comprar e vender USDT. As operações em andamento terminam normalmente.",
  toast_crypto_rollout_on: "Cripto ligado para todas as organizações",
  col_card_deposits: "QR de stablecoins",
  card_deposits_switch_aria: "QR de depósito de stablecoins para {{name}}",
  toast_card_deposits_enabled: "QR de depósito de stablecoins visível nos cartões de {{name}}",
  toast_card_deposits_disabled:
    "QR de depósito de stablecoins oculto para {{name}}. Os depósitos que chegarem mesmo assim são registrados.",
  card_deposits_rollout_body_on:
    "Ligado: todos os cartões cripto mostram o QR, independentemente da chave da organização.",
  card_deposits_rollout_body_off:
    "Cada uma decide: só os cartões das organizações que você habilitar uma a uma o mostram.",
  card_deposits_rollout_switch_aria: "QR de depósito de stablecoins para todas as organizações",
  card_deposits_rollout_confirm_on_title: "Mostrar o QR de depósito em todos os cartões cripto?",
  card_deposits_rollout_confirm_on_body:
    "Todas as organizações verão o endereço de depósito dos seus cartões cripto e poderão recarregá-los enviando USDT ou USDC pela Polygon.",
  card_deposits_rollout_confirm_off_body:
    "Só as organizações habilitadas uma a uma verão o QR. Os depósitos que chegarem a endereços já compartilhados continuam sendo registrados.",
  toast_card_deposits_rollout_on: "QR de depósito de stablecoins visível para todas as organizações",
  col_card_cop_top_ups: "Pesos → cartão",
  card_cop_top_ups_switch_aria: "Recarregar cartões com pesos para {{name}}",
  toast_card_cop_top_ups_enabled: "{{name}} já pode recarregar seus cartões cripto com seu saldo em pesos",
  toast_card_cop_top_ups_disabled:
    "Recarga de cartões com pesos desligada para {{name}}. As recargas em andamento terminam normalmente.",
  card_cop_top_ups_rollout_body_on:
    "Ligado: todas as organizações podem recarregar seus cartões cripto com o saldo em pesos, independentemente da chave própria.",
  card_cop_top_ups_rollout_body_off:
    "Cada uma decide: só têm as organizações que você habilitar uma por uma. É independente do QR de stablecoins.",
  card_cop_top_ups_rollout_switch_aria: "Recarregar cartões com pesos para todas as organizações",
  card_cop_top_ups_rollout_confirm_on_title: "Habilitar a recarga de cartões com pesos para todas?",
  card_cop_top_ups_rollout_confirm_on_body:
    "Todas as organizações verão «Saldo em pesos» ao recarregar seus cartões cripto: compramos USDT com seus pesos e enviamos ao cartão.",
  card_cop_top_ups_rollout_confirm_off_body:
    "Só as organizações habilitadas uma por uma continuarão vendo. As recargas já feitas terminam normalmente.",
  toast_card_cop_top_ups_rollout_on: "Recarga de cartões com pesos habilitada para todas as organizações",
  custom_key_action: "Atribuir chave personalizada",
  custom_key_action_aria: "Atribuir uma chave Bre-B personalizada a {{name}}",
  custom_key_title: "Chave personalizada para {{name}}",
  custom_key_description:
    "Uma chave sob medida, em vez das que são geradas com os dados da organização. Só pessoas autorizadas veem esta opção.",
  custom_key_input_label: "Chave",
  custom_key_input_placeholder: "suaempresa",
  custom_key_format_hint: "De 5 a 20 letras ou números, sem espaços, acentos ou símbolos.",
  custom_key_invalid: "Use de 5 a 20 letras ou números, sem espaços, acentos ou símbolos.",
  custom_key_checking: "Verificando…",
  custom_key_available: "Disponível",
  custom_key_taken_coloca: "Ocupada por uma conta da Coloca",
  custom_key_taken_elsewhere: "Registrada em outra instituição Bre-B",
  custom_key_unknown: "Não conseguimos verificá-la",
  custom_key_check_again: "Verificar de novo",
  custom_key_preview_label: "Como quem paga vai vê-la",
  custom_key_rollout_note:
    "A organização não precisa ter a chave Bre-B habilitada. Depois, ela usa a chave e pode excluí-la como qualquer outra.",
  custom_key_keys_title: "Chaves de {{name}}",
  custom_key_assign_another: "Atribuir outra chave personalizada",
  custom_key_not_verified:
    "A verificação da organização não está aprovada, então ainda não é possível atribuir uma chave.",
  custom_key_rail_disabled: "As cobranças Bre-B estão desligadas para esta organização.",
  custom_key_load_error: "Não conseguimos ler a chave da organização.",
  custom_key_retry: "Tentar de novo",
  custom_key_assign: "Atribuir chave",
  custom_key_cancel: "Cancelar",
  custom_key_two_factor_required: "Ative a verificação em duas etapas para atribuir chaves.",
  custom_key_two_factor_description:
    "Digite o código do seu app autenticador para atribuir {{key}} a {{name}}.",
  custom_key_assigned_toast: "Você atribuiu a chave {{key}} a {{name}}.",
  custom_key_assigned_pending_toast:
    "Você atribuiu a chave {{key}} a {{name}}. Ela fica ativa em alguns segundos.",
  custom_key_transfer_action: "Transferir para outra organização",
  custom_key_transfer_action_aria: "Transferir a chave {{key}} para outra organização",
  custom_key_transfer_title: "Transferir {{key}}",
  custom_key_transfer_description:
    "A chave passa para outra organização sem ser apagada do Bre-B, assim ninguém pode ficar com ela no caminho.",
  custom_key_transfer_picker_label: "Organização que a recebe",
  custom_key_transfer_picker_required_hint: "Escolha a organização que fica com a chave.",
  custom_key_transfer_picker_org_hint: "Abaixo você vê o que muda em cada organização.",
  custom_key_transfer_same_org: "Essa organização já tem a chave. Escolha outra.",
  custom_key_transfer_loading: "Verificando o que muda…",
  custom_key_transfer_side_from: "De",
  custom_key_transfer_side_to: "Para",
  custom_key_transfer_primary: "Chave principal",
  custom_key_transfer_primary_shared: "A geral da Coloca",
  custom_key_transfer_primary_changes: "Muda",
  custom_key_transfer_primary_same: "Sem mudanças",
  custom_key_transfer_primary_this: "Passa a ser esta",
  custom_key_transfer_arrives_as: "Em {{name}} fica como chave do tipo {{source}}.",
  custom_key_transfer_static_qr:
    "O QR sem valor vai junto com a chave: o que for pago por ele chega a {{name}}.",
  custom_key_transfer_live_qrs:
    "{{name}} tem {{count}} cobrança(s) com QR ainda válido(s) sobre esta chave. Se forem pagas, o dinheiro chega a {{name}}; vencem em no máximo 60 minutos.",
  custom_key_transfer_in_flight:
    "Um pagamento que chegue exatamente no minuto da mudança fica retido para ser conciliado manualmente.",
  custom_key_transfer_otc_title: "{{name}} tem operações de USDT em andamento com esta chave",
  custom_key_transfer_otc_sales: "{{count}} venda(s) ainda podem pagar os pesos nesta chave.",
  custom_key_transfer_otc_purchases: "{{count}} compra(s) seriam reembolsadas nesta chave se falharem.",
  custom_key_transfer_otc_wait: "Você poderá movê-la quando terminarem.",
  custom_key_transfer_problem_title: "{{name}} ainda não pode receber a chave",
  custom_key_transfer_problem_verification_required:
    "Ainda não tem a verificação aprovada. Quando for aprovada, você poderá transferir a chave para ela.",
  custom_key_transfer_problem_rail_disabled:
    "Tem as cobranças Bre-B desligadas, então não pode receber a chave.",
  custom_key_transfer_problem_no_pricing:
    "Não tem rota nem comissão configurada para cobranças Bre-B, então não é possível definir os valores da chave.",
  custom_key_transfer_submit: "Transferir chave",
  custom_key_transfer_two_factor_required: "Ative a autenticação em duas etapas para transferir chaves.",
  custom_key_transfer_two_factor_description:
    "Digite o código do seu app autenticador para transferir {{key}} para {{name}}.",
  custom_key_transferred_toast: "Você transferiu a chave {{key}} para {{name}}.",
  col_features: "Funcionalidades",
  features_none: "Nenhuma",
  features_only_global: "Só as gerais",
  features_for_all: "Ligadas para todas: {{features}}",
  action_change: "Alterar",
  action_configure: "Configurar",
  configure_aria: "Configurar {{name}}",
  action_global_settings: "Configuração geral",
  detail_id: "ID",
  copy_id_aria: "Copiar o ID",
  id_copied: "ID copiado",
  features_title: "Funcionalidades",
  features_hint: "As alterações são salvas na hora.",
  features_read_only: "Somente leitura: você não tem permissão para editar organizações.",
  feature_global_note: "Ligada para todas pela configuração geral.",
  feature_payout_batches_description:
    "Os membros enviam um arquivo e pagam muitos beneficiários em uma só operação, com a aprovação de uma segunda pessoa.",
  feature_breb_key_description:
    "Pode criar sua própria chave Bre-B para receber transferências e seu QR para qualquer valor.",
  feature_crypto_description:
    "Pode comprar USDT com o saldo da carteira em pesos e vender USDT para receber pesos.",
  feature_card_deposits_description:
    "Os cartões cripto mostram o endereço de depósito (QR) para recarregá-los com USDT ou USDC.",
  feature_card_cop_top_ups_description:
    "Os cartões cripto podem ser recarregados com o saldo em pesos: compramos USDT e enviamos ao cartão.",
  global_settings_title: "Configuração geral",
  global_settings_description:
    "Cada funcionalidade pode ficar a critério de cada organização, ligada para todas ou desligada para todas. Enquanto estiver ligada ou desligada para todas, o interruptor de cada organização não conta, mas é mantido.",
  global_settings_load_error: "Não conseguimos ler a configuração geral.",
  payout_batches_rollout_body_on: "Ligado para todas as organizações, independentemente da chave própria.",
  payout_batches_rollout_body_off: "Cada uma decide: só as organizações que você habilitar uma a uma o têm.",
  payout_batches_rollout_switch_aria: "Pagamentos em lote para todas as organizações",
  payout_batches_rollout_confirm_on_title: "Ligar pagamentos em lote para todas as organizações?",
  payout_batches_rollout_confirm_on_body:
    "Os membros de qualquer organização poderão enviar, revisar e aprovar lotes pelo dashboard.",
  payout_batches_rollout_confirm_off_body:
    "Só as organizações habilitadas uma a uma continuarão com o módulo. Os lotes que já estão sendo pagos terminam normalmente.",
  toast_payout_batches_rollout_on: "Pagamentos em lote ligado para todas as organizações",
  col_breb_qr_payments: "Pagar com QR",
  feature_breb_qr_payments_description:
    "Pode pagar códigos QR Bre-B de estabelecimentos e pessoas com o saldo da carteira em pesos.",
  breb_qr_payments_switch_aria: "Pagar com QR para {{name}}",
  toast_breb_qr_payments_enabled: "{{name}} já pode pagar com QR",
  toast_breb_qr_payments_disabled:
    "Pagar com QR desligado para {{name}}. Os pagamentos já enviados seguem normalmente.",
  breb_qr_payments_rollout_body_on:
    "Ligado: todas as organizações podem pagar QR, independentemente do interruptor de cada uma.",
  breb_qr_payments_rollout_body_off:
    "Cada uma decide: só pagam QR as organizações que você habilitar uma por uma.",
  breb_qr_payments_rollout_switch_aria: "Pagar com QR para todas as organizações",
  breb_qr_payments_rollout_confirm_on_title: "Ligar pagar com QR para todas as organizações?",
  breb_qr_payments_rollout_confirm_on_body:
    "Todas as organizações poderão escanear e pagar códigos QR Bre-B pela carteira em pesos.",
  breb_qr_payments_rollout_confirm_off_body:
    "Só as organizações habilitadas uma por uma poderão pagar QR. Os pagamentos já enviados seguem normalmente.",
  toast_breb_qr_payments_rollout_on: "Pagar com QR ligado para todas as organizações",

  matched_user: "Usuário: {{name}} · {{email}}",
  matched_users_more: "+{{count}}",

  tab_overview: "Resumo",
  tab_users: "Usuários",
  tab_features: "Funcionalidades",
  overview_load_error: "Não conseguimos carregar o resumo desta organização.",
  overview_forbidden: "Seu papel não tem as permissões de leitura para ver o resumo das organizações.",

  overview_status_title: "Situação",
  overview_verification_label: "Verificação",
  overview_purpose_kyc: "KYC",
  overview_purpose_kyb: "KYB",
  identity_type_business: "Empresa",
  identity_type_individual: "Pessoa",
  overview_verification_none: "Ainda não tem identidade própria: a verificação não começou.",
  overview_verification_verified_at: "Aprovada em {{date}}.",
  overview_verification_in_review: "Estamos revisando.",
  overview_verification_pending: "Ainda não terminou de enviar os dados.",
  overview_verification_expired: "Venceu: precisa ser verificada de novo.",
  overview_cards_label: "Cartões",
  overview_cards_provider_label: "Cartões · {{provider}}",
  overview_cards_no_provider: "Não tem provedor de cartões atribuído.",
  overview_cards_own_none: "Sem registro próprio",
  overview_cards_paused: "Pausado: {{reason}}",
  overview_cards_holders_label: "Titulares",
  overview_cards_holders_none: "Ainda não tem titulares registrados.",
  overview_access_label: "Acesso",
  overview_access_active: "Ativos: {{count}}",
  overview_access_none: "Não tem usuários: ninguém pode entrar no dashboard.",
  overview_access_last_login: "Último acesso {{when}}, {{name}}.",
  overview_access_never: "Nenhum usuário entrou ainda.",
  provider_crypto: "Coloca Crypto",
  provider_cards: "Coloca Cards",

  stage_not_registered: "Sem registro",
  stage_in_progress: "Em andamento",
  stage_paused: "Pausado",
  stage_in_review: "Em revisão",
  stage_enabled: "Habilitado",
  stage_rejected: "Rejeitado",
  holders_not_registered: "sem registro",
  holders_in_progress: "em andamento",
  holders_paused: "pausados",
  holders_in_review: "em revisão",
  holders_enabled: "habilitados",
  holders_rejected: "rejeitados",
  pause_reason_business_identity: "é uma empresa, e só pessoas podem ser titulares",
  pause_reason_missing_identity_fields: "falta o sobrenome ou a data de nascimento",
  pause_reason_missing_email: "falta um e-mail de contato",
  pause_reason_missing_address: "falta o endereço residencial",
  pause_reason_unmappable_state: "não reconhecemos o estado do endereço",
  pause_reason_missing_client_data: "faltam dados do titular",
  pause_reason_documents_unavailable: "não conseguimos trazer os documentos da verificação",
  pause_reason_already_registered: "a pessoa já está registrada com outra identidade",
  pause_reason_other: "outro motivo; veja os alertas da equipe",

  overview_details_title: "Dados",
  detail_phone: "Telefone",
  detail_created_by: "por {{name}}",

  overview_activity_title: "Atividade",
  activity_wallets: "Carteiras",
  activity_wallets_none: "Não tem carteiras ativadas.",
  wallet_frozen: "congelada",
  wallet_closed: "fechada",
  activity_last_payin: "Última cobrança",
  activity_last_payout: "Último envio",
  activity_last_value: "{{when}} · {{count}} em 30 dias",
  activity_never: "Nunca",
  activity_cards: "Cartões",
  activity_cards_value: "{{total}} · ativos {{active}} · congelados {{frozen}}",
  activity_holders: "Titulares",
  activity_breb_keys: "Chaves Bre-B",
  activity_api_keys: "API keys",
  activity_api_keys_value: "Ativas: {{count}}",
  activity_api_keys_used: "Ativas: {{count}} · usada {{when}}",
  activity_none: "Nenhuma",

  member_status_active: "Ativo",
  member_status_pending_verification: "Não verificado",
  member_status_inactive: "Desativado",
  member_status_suspended: "Suspenso",
  members_active: "Ativos",
  members_pending_verification: "Não verificados",
  members_inactive: "Desativados",
  members_suspended: "Suspensos",
  users_empty_title: "Não tem usuários",
  users_empty_description: "Ninguém desta organização pode entrar no dashboard.",
  user_last_login: "Entrou {{when}}",
  user_never_logged_in: "Nunca entrou",
  user_two_factor: "2FA ativo",
  copy_email_aria: "Copiar o e-mail de {{name}}",
  email_copied: "E-mail copiado",
  users_truncated: "Mostrando os primeiros {{count}}.",
  col_card_wallet: "Carteira de cartões",
  card_wallet_switch_aria: "Carteira de cartões para {{name}}",
  toast_card_wallet_enabled: "{{name}} já tem a carteira de cartões: pode retirar saldo dos seus cartões",
  toast_card_wallet_disabled:
    "Carteira de cartões desligada para {{name}}. Os cartões são recarregados com pesos ou cripto e o saldo só se move entre cartões.",
  feature_card_wallet_description:
    "Um saldo em dólares para recarregar os cartões na hora e retirar saldo deles. Sem ela, os cartões cripto são recarregados com pesos ou cripto e o saldo só se move entre cartões.",
  col_card_design: "Personalizar cartão",
  card_design_switch_aria: "Personalizar cartão para {{name}}",
  toast_card_design_enabled:
    "{{name}} já pode personalizar os seus cartões: o design aparece na visualização segura do cartão",
  toast_card_design_disabled:
    "Personalização desligada para {{name}}. Os cartões voltam ao design Coloca; o design fica salvo.",
  feature_card_design_description:
    "Cores e logo próprios, ao lado da marca Coloca, na visualização segura do cartão que mostra pela API. O cartão no Apple Pay ou Google Pay não muda.",
};
